import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const CountryInput = ({name, label, options, load, rules=[], multiple=false, onChange=null, ...props}) => {

  // load countries on mount
  useEffect(() => {
    load();
  }, [load]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select
            showSearch
            mode={multiple ? "multiple" : null}
            disabled={props.isLoading || props.isSubmitting}
            loading={props.isLoading}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={onChange}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default CountryInput;
